<template>
  <div class="com-table balance border">
    <div class="com-title pr">接收报表</div>
    <div class="ms-list">
      <div ref="msSearch" class="resource-search">
        <el-button type="primary" @click="exportFile()" class="dia-btn exportFile">导出</el-button>
        <ms-search :data="search.list" @click="updateConditions"/>
      </div>

      <el-table
        class="receliveList"
        v-loading="table.loading"
        size="small"  
        :data="this.table.list"
        border
        :fit="true"
        show-summary>
        <template slot="empty">
          <no-data></no-data>
        </template>
        <el-table-column prop="dateTime" label="日期" min-width="120"></el-table-column>
        <el-table-column align="center" prop="itemTitle"  label="项目名称" min-width="80">
          <template slot-scope="scope">
            <!-- <template v-if="scope.row.readStatus === 0">
              <i class="unRead-icon"></i>
            </template> -->
            {{scope.row.itemTitle}}
          </template>
        </el-table-column>
        <el-table-column prop="crmFollower" label="接收人" min-width="70"></el-table-column>
        <el-table-column prop="countNum" label="资源获得量（条）" min-width="80"></el-table-column>
      </el-table>

      <el-pagination
        class="pagination"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="table.pagination.page"
        :total="table.pagination.totalRow"
        :page-size="table.pagination.pageSize"
        :page-sizes="table.pagination.pageSizes"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>

</template>

<script>
  import MsSearch from '@/components/common/Search.vue'
  import moment from 'moment'
  import Items from '@/api/items'
  import Api from '@/api/client/receive-list'
  import ResponseParse from '@/utils/response-parse'
  import { SEARCH_CONDITION } from '@/models/client/receive-list'

  export default {
    components: {
      MsSearch
    },
    data () {
      return {
        dialogVisible: false,
        showChannel: false,
        search: {
          list: [],
          condition: {}
        },
        table: {
          list: [],
          pagination: {}
        },
        message: {
          remark: ''
        },
        num1: 0,
        num2: 0
      }
    },
    created () {
      this.search.list = SEARCH_CONDITION
      let date = []
      date[0] = moment().subtract(0, 'days').format('YYYY-MM-DD')
      date[1] = moment().subtract(0, 'days').format('YYYY-MM-DD')
      this.search.condition.startTime = date[0]
      this.search.condition.endTime = date[1]
      this.search.condition.dataGroup = '1'
      this.search.list[0].value = date
      Items.getItems(response => {
        let itemTitle = response.data.data
        let title = []
        itemTitle.forEach(value => {
          title.push({value: value.id, label: value.title})
        })
        this.search.list[2].config.list = title
      })

      this.table.list = []
      this.requestList()
    },
    methods: {
      requestList () {
        // this.table.pagination.pageSize = 50
        let params = Object.assign({}, this.table.pagination, this.search.condition)
        Api.list({search: params}, response => {
          let status = response.status || 0
          let body = response.data || []
          if ((status >= 200 || status <= 204) && body.length > 0) {
            this.table.list = body
            this.table.pagination = ResponseParse.pagination(response.headers)
            if (this.table.list[0].channelTitle !== undefined) {
              this.showChannel = true
            } else {
              this.showChannel = false
            }
          } else {
            this.showChannel = false
            this.table.list = []
          }
        })
      },
      handleSizeChange (val) {
        this.table.pagination.pageSize = val
        this.requestList()
      },
      handleCurrentChange (val) {
        this.table.pagination.page = val
        this.requestList()
      },
      updateConditions (conditions) {
        this.table.pagination.page = 1
        const time = conditions.time || []
        this.search.condition = Object.assign({}, conditions, {startTime: time[0], endTime: time[1]})
        this.requestList()
      },
      popUs (index) {
        this.dialogVisible = true
        this.message.index = index
        this.message.remark = this.table.list[index].remark
        this.message.id = this.table.list[index].id
      },
      modifierRemrak () {
        Api.modify({id: this.message.id, remark: this.message.remark}, response => {
          let status = response.status || 0
          if (status >= 200 && status <= 204) {
            let data = this.table.list[this.message.index]
            data.remark = this.message.remark
            this.table.list.splice(this.message.index, 1, data)
            this.dialogVisible = false
            this.$message.success('修改成功')
          } else {
            this.$message.error('修改失败')
          }
        })
      },
      exportFile () {
        let search = ''
        this.search.list.forEach(item => {
          let text = item.name
          let value = item.value
          if (item.type === 'select') {
            if (item.hasOwnProperty('config') && item.config.hasOwnProperty('list')) {
              item.config.list.forEach(function (option) {
                if (option.label === item.value) {
                  value = option.value
                }
              })
            }
          }
          if (search === '') {
            if (text === 'time' && value !== '') {
              search = '?startTime=' + value[0] + '&endTime=' + value[1]
            } else {
              if (value !== '') {
                search = '?' + text + '=' + value
              }
            }
          } else {
            if (text === 'time' && value !== '') {
              search = '&startTime=' + value[0] + '&endTime=' + value[1]
            } else {
              if (value !== '') {
                search += '&' + text + '=' + value
              }
            }
          }
        })
        window.location.href = '/rest/customer/feedback/resourceCount/downloadlist' + search
      }
    }
  }
</script>
<style lang="scss">
.receliveList .el-table__footer .has-gutter td .cell {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/client/ReceiveList.vue